module.exports = __webpack_public_path__ + "img/logo.e8275da2.svg";